import PropTypes from 'prop-types';

export const ItalicizedQuote = ({ text }) => {
  const match = text.match(/"(.*?)"/);

  if (!match) {
    return (text); // No quotes found, return as is
  }

  const [fullMatch, quotedPart] = match;
  const [before, after] = text.split(fullMatch);

  return (
    <>
      {before}
      <i>
        {`"${quotedPart}"`}
      </i>
      {after}
    </>
  );
};

ItalicizedQuote.propTypes = {
  text: PropTypes.string.isRequired,
};
